"use strict";

const Popout = () => {
    const init = () => {
        $(function() {
            var $popout = $('.js-popout');
            var $timedPopout = $('.js-timed-popout');
            var $anchorPopup = $('a[href*="#"]')

            window.resetPopoutTriggers = function(){
                var $popoutTriggers = $('.js-popout-trigger');
                
                $popoutTriggers.off('click');
                $popoutTriggers.on('click', function(){
                    openPopup($(this).data('popout'));
                    if($(this).data('houseland')){
                        $popout.filter('.js-popout[data-hash="'+ $(this).data('popout') +'"]').find('[name="houseland"]').val($(this).data('houseland'));
                    }
                });

                $anchorPopup.off('click')
                $anchorPopup.on('click', function() {
                    var hash = $(this).attr('href').replace('#', '')
                    if(hash == 'scroll-to-enquiry-form' && $('.module-contact-form').length){
                        $('html, body').animate({
                            scrollTop: $('.module-contact-form').offset().top - 40
                        }, 100);
                    }else{
                        openPopup(hash);
                    }
                })
            }

            window.scrollToEnquiryForm = function(){
                $('html, body').animate({
                    scrollTop: $('.module-contact-form').offset().top - 40
                }, 100);
            }

            const openPopup = (hash) => {
                $popout.removeClass('open');
                $popout.filter('.js-popout[data-hash="'+ hash +'"]').addClass('open').removeClass('js-timed-popout');
            }

            resetPopoutTriggers();
            
            $popout.find('.js-popout-close').on('click', function(){
                $popout.removeClass('open timed-open js-timed-popout');
            });

            window.closePopout = function(){
                $('.js-popout').removeClass('open timed-open js-timed-popout');
            };

            $timedPopout.each(function(){
                var $this = $(this);
                if($this.data('time')){
                    var time = $this.data('time');
                }else{
                    var time = 30000;
                }
                setTimeout(function () {
                    if($popout.filter('.open').length <= 0){
                        $this.addClass('timed-open');
                    }
                }, time);
            });

            if(window.location.hash){
                var hash = window.location.hash.replace('#', '');
                if(hash == 'show-finance-form'){
                    openPopup('finance-form');
                }else if($('[data-anchor="'+hash+'"]').length){
                    $('html, body').animate({
                        scrollTop: $('[data-anchor="'+hash+'"]').offset().top - 40
                    }, 100);
                }
            }
        });
    };

    return {
        init:init
    };
};

export default Popout;